import { Flex, Text } from '@chakra-ui/react';

export const FormNotes = ({ noteValue, props = {} }) => {
  return (
    <Flex
      alignItems="center"
      p="15px"
      background="ats-bg-primary"
      mt="4px"
      borderRadius="6px"
      {...props}
    >
      <Text fontSize="sm" ml="4px">
        <b>Note:</b> {noteValue}
      </Text>
    </Flex>
  );
};
